module.exports = __webpack_public_path__ + "assets/img/I90-M.f7d1b3aa.png";